import { render } from "./ItemInfo.vue?vue&type=template&id=31544e32&scoped=true"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"

import "./ItemInfo.vue?vue&type=style&index=0&id=31544e32&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31544e32"]])

export default __exports__